import { ChangeDetectionStrategy, Component, forwardRef } from "@angular/core";
import { RangeValue } from "@ionic/core";
import { FormQuestion, SliderQuestion } from "../../../checklist.interface";
import { QuestionComponent } from "../question.component";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
	selector: "app-slider-question",
	templateUrl: "./slider-question.component.html",
	styleUrls: ["./slider-question.component.scss"],
	changeDetection: ChangeDetectionStrategy.Default,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => SliderQuestionComponent),
			multi: true,
		},
	],
})
export class SliderQuestionComponent extends QuestionComponent<SliderQuestion> implements ControlValueAccessor {
	model: SliderQuestionModel = {
		value: null,
		step: null,
	};

	protected pinFormatter(value: number) {
		return `${value}`;
	}

	private getStepForSlider() {
		const isDecimal = (value: number) => {
			return value && Math.floor(value) !== value;
		};

		const numDecimals = (value: number) => {
			return value?.toString().split(".")[1]?.length || 0;
		};

		if (!(isDecimal(this.question.minimum) || isDecimal(this.question.maximum))) {
			return 1;
		}

		const limitDecimalsLength = [numDecimals(this.question.minimum), numDecimals(this.question.maximum)];
		const maxNumDecimals = Math.max(...limitDecimalsLength);
		return Math.pow(10, -maxNumDecimals);
	}

	override writeValue(answer: FormQuestion | undefined): void {
		super.writeValue(answer);
		this.model.value = answer?.answers.length == 0 ? null : answer?.answers[0];

		this.model.step = this.getStepForSlider();
	}

	async onChange(input: number | RangeValue) {
		this.model.value = input.toString();

		const answer = this.model.value;

		this.setAnswers(answer);
		this.onTouched();
	}
}

interface SliderQuestionModel {
	value: string;
	step: number;
}
